module.exports = __webpack_public_path__ + "img/zfb_6.c1189127.png";